'use strict';/* global define:false */define('modules/core/modules/dashboard/directives/updates/index',['require','text!./template.html','./controller'],function(require){'use strict';/**
   * updates directive
   *
   * @tested
   */function directive(){return{restrict:'E',template:require('text!./template.html'),controller:require('./controller'),controllerAs:'UpdatesCtrl',link:function link(scope,element,attrs,ctrl){ctrl.max=+attrs.max;ctrl.more=+attrs.more;ctrl.showHeader='showHeader'in attrs;},scope:{}};}return directive;});
